export const styles = () => ({
  heading: {
    fontSize: 36,
    color: '#3A3F62',
    marginTop: 64,
  },
  paragraph: {
    fontSize: 14,
    textAlign: 'center',
    color: '#616581',
    margin: '16px auto 24px',
  },
  main: {
    display: 'flex',
    justifyContent: 'center',
    height: '100vh',
    flexDirection: 'column',
    width: '100%',
    alignItems: 'center',
  },
  back: {
    padding: '13px 28px',
    border: 0,
    background: '#1658F3',
    boxShadow: '0px 3px 9px rgba(19, 69, 186, 0.206267)',
    borderRadius: 10,
    cursor: 'pointer',
    color: 'white',
    margin: '30px auto 0',
    display: 'block',
  },
})
